/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

export function a11yTabProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
